import { render } from "./InputPrefix.vue?vue&type=template&id=031dce28&ts=true"
import script from "./InputPrefix.vue?vue&type=script&lang=ts"
export * from "./InputPrefix.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__